import careersTypes from '../types/careers';
import agentsTypes from "../types/agents";
import api from "../../api/api";
import paymentTypes from "../types/payment";

const setJobList = (array) => ({
    type: careersTypes.SET_JOB_LIST,
    array,
});
const setJob = (object) => ({
    type: careersTypes.SET_JOB,
    object,
});
const setModalOpen = (boolean) => ({
    type: careersTypes.SET_MODAL_OPEN,
    boolean,
});
const setModalSuccessOpen = (boolean) => ({
    type: careersTypes.SET_MODAL_SUCCESS_OPEN,
    boolean,
});
const setModalAgentOpen = (boolean) => ({
    type: careersTypes.SET_MODAL_AGENT_OPEN,
    boolean,
});
const setFormJobPosition = (text) => ({
    type: careersTypes.SET_FORM_JOB_POSITION,
    text,
});
const setLoading = (boolean) => ({
    type: careersTypes.SET_LOADING,
    boolean,
});


const fetchJobs = () => async (dispatch) => {
    dispatch(setLoading(true))
    const responseData = [];
    const response = await api.get(`/careers`);
    
    // API Platform returns data in hydra:member format
    const dataArray = response.data['hydra:member'] || response.data || [];
    dataArray.forEach((elem) => {
        responseData.push({...elem});
    })
    const jobsSorted = responseData.sort((a, b) => a.position > b.position ? 1 : -1);
    dispatch(setJobList(jobsSorted));
    dispatch(setLoading(false));
};

const fetchJob = (id) => async (dispatch) => {
    dispatch(setLoading(true))
    const response = await api.get(`/careers/${id.id}`);
    dispatch(setJob(response.data));
    dispatch(setLoading(false));
};

export default {
    setJobList,
    fetchJobs,
    fetchJob,
    setJob,
    setModalOpen,
    setModalAgentOpen,
    setModalSuccessOpen,
    setFormJobPosition
};
